import ManageFertilizerTable from './ManageFertilizerTable'

const ManageFertilizer = {
  Table: ManageFertilizerTable,
}

export default ManageFertilizer
